const { gql } = require('@apollo/client');

export const BRAND_QUERY = gql`
  query Brands {
    productBrands(first: 200) {
      edges {
        node {
          name
          slug
          id
        }
      }
    }
  }
`;
